import React from "react";

const MaskArea = (props) => {
  const getPath = () => {
    const outer = `M0,0 L0,${props.dynamicImageSize.height} L${props.dynamicImageSize.width},${props.dynamicImageSize.height} L${props.dynamicImageSize.width},0 Z`;
    const inner = `M${props.floatWinPos.x},${props.floatWinPos.y} L${props.floatWinPos.x + props.floatWinSize.width},${props.floatWinPos.y} L${props.floatWinPos.x + props.floatWinSize.width},${props.floatWinPos.y + props.floatWinSize.height} L${props.floatWinPos.x},${props.floatWinPos.y + props.floatWinSize.height} L${props.floatWinPos.x},${props.floatWinPos.y} Z`;
    return outer + inner;
  };

  const svgStyle = {
    fill: "#000000",
    width: props.dynamicImageSize.width,
    height: props.dynamicImageSize.height,
    opacity: "50%",
  };

  const pathStyle = {
    fillRule: "evenodd",
  };

  return (
    <svg style={svgStyle}>
      <path style={pathStyle} d={getPath()} />
    </svg>
  );
};

export default MaskArea;
